import Vue from 'vue'
import {UserRoleEnum} from '@/enums/userRolesEnum'
import {BallPulseLoader} from 'vue-loaders';
import TitleDropdownPicker from "@/componentsReusable/TitleDropdownPicker.vue";
import {TitleDropdownOption} from "@/componentsReusable/TitleDropdownOption";
import MessageInboxCard from "@/components/communications/cards/MessageInboxCard";
import MessageCategoryCard from "@/components/communications/cards/MessageCategoryCard";
import HttpMixin from "@/mixins/HttpMixin";
import {CampaignItem, CommunicationType, MessageContainer} from "@/components/communications/CommunicationInterfaces";
import {ViewStateType} from "@/enums/ViewStateType";
import NewCampaignResultsDisplay from "@/components/communications/campaign/results/NewCampaignResultsDisplay";
import CampaignMessageCard from "@/components/communications/campaign/CampaignMessageCard/CampaignMessageCard";
import CampaignEmailDisplay from "@/components/communications/campaign/CampaignEmailDisplay/CampaignEmailDisplay";
import CampaignInboxCard from "@/components/communications/cards/CampaignInboxCard";
import { ContactType} from "@/components/communications/models/contactModel";
import ProviderModal from "@/componentsReusable/ProviderModal.vue";
import FacilityContactModal from "@/componentsReusable/FacilityContactModal.vue";

export default Vue.extend({
  name: 'Communications',
  mixins: [ HttpMixin ],
  components: {
    BallPulseLoader,
    TitleDropdownPicker,
    MessageInboxCard,
    MessageCategoryCard,
    NewCampaignResultsDisplay,
    CampaignMessageCard,
    CampaignInboxCard,
    CampaignEmailDisplay,
    ProviderModal,
    FacilityContactModal
  },
  data () {
    return {
      cardExpanded: true,
      UserRoleEnum: UserRoleEnum,
      isAuthorizedForNewCampaign: false,
      loadingInitialData: false,
      messageOptions:[{text:"Texts", id:1, bulletClass:""},{text:"Emails",id:2, bulletClass:""}],
      contactOptions:[{text:"Provider", id:1, bulletClass:"nav-circle background-blue"},{text:"Facility Contacts",id:2, bulletClass:"nav-circle background-red"}],
      selectedMessageType: {} as TitleDropdownOption,
      selectedContactType:{} as TitleDropdownOption,
      provider: {} as any,
      selectedCampaign: {} as CampaignItem,
      selectedContacts: [] as any,
      selectedReceiver:{} as TitleDropdownOption,
      MessageContainer: MessageContainer,
      facilityContact: {} as any,
      showProviderSelectionModal: false,
      showFacilityContactSelectionModal: false,
      dropCount: 0,
      providerId: this.$route.params.providerId || 0,
      providerName: this.$route.params.providerName || '',
      facilityContactId: this.$route.params.facilityContactId || 0,
      facilityContactName: this.$route.params.facilityContactName || '',
    }
  },
  computed: {
    isSms (): boolean {
      return this.selectedMessageType.id === CommunicationType.SMS;
    }
  },
  watch: {
    async selectedMessageType() {
      await this.$store.dispatch('viewState/updateViewState', {
        name: ViewStateType.COMMUNICATION_SELECTED_MESSAGE_TYPE,
        value: this.selectedMessageType
      });
    },
    async selectedContactType() {
      await this.$store.dispatch('viewState/updateViewState', {
        name: ViewStateType.COMMUNICATION_SELECTED_RECEIVER,
        value: this.selectedContactType
      });
    },
  },
  beforeMount: function () {
    this.isAuthorizedForNewCampaign = this.$store.getters['user/hasRole']([UserRoleEnum.MANAGER, UserRoleEnum.COMMUNICATIONS]);
  },
  async created() {
    this.selectedMessageType = this.$store.state.viewState[ViewStateType.COMMUNICATION_SELECTED_MESSAGE_TYPE]
      ? this.$store.state.viewState[ViewStateType.COMMUNICATION_SELECTED_MESSAGE_TYPE]
      : this.messageOptions[0];
    this.selectedContactType = this.$store.state.viewState[ViewStateType.COMMUNICATION_SELECTED_RECEIVER]
      ? this.$store.state.viewState[ViewStateType.COMMUNICATION_SELECTED_RECEIVER]
      : this.contactOptions[0];
    await this.$store.dispatch('communication/loadContainerMessages', {
      messageType: this.selectedMessageType.id,
      contactType: this.selectedContactType.id
    });
  },
  methods:{
    goToNewCampaign(){
      this.$router.push({
        name: 'NewCommunicationsCampaign',
        params: {recipientTypeId: this.selectedContactType.id.toString(), messageTypeText: this.selectedMessageType.text}
      });
    },
    showContactModal() {
      if (this.selectedContactType.id === ContactType.Provider) {
        this.showProviderModal();
      } else if (this.selectedContactType.id === ContactType.FacilityContact) {
        this.showFacilityContactModal();
      }
    },
    showProviderModal () {
      this.showProviderSelectionModal = true;
    },
    showFacilityContactModal () {
      this.showFacilityContactSelectionModal = true;
    },
    confirmProvider (provider: any) {
      this.showProviderSelectionModal = false;
      this.providerId = provider.id;
      this.providerName = `${provider.firstName} ${provider.lastName}`;
    },
    confirmFacilityContact (facilityContact: any) {
      this.showFacilityContactSelectionModal = false;
      this.facilityContactId = facilityContact.facilityContactId;
      this.facilityContactName = facilityContact.name;
    },
    async showRecipientsAndContent(campaign: CampaignItem) {
      this.selectedCampaign = campaign;
      if (this.selectedContactType.id === ContactType.Provider) {
        this.selectedContacts = await (this as any).httpPost('/providers/id-search', 'Failed to retrieve Providers.', {
          providerIds: campaign.recipientIds,
        }) || [];
        this.selectedContacts.map((contact: any) => {
          contact.contactType = ContactType.Provider
        })
      } else if (this.selectedContactType.id === ContactType.FacilityContact) {
        this.selectedContacts = await (this as any).httpPost('/facility-contact/id-search', 'Failed to retrieve Facility Contacts.', {
          facilityContactIds: campaign.recipientIds,
        }) || [];
        this.selectedContacts.map((contact: any) => {
          contact.contactType = ContactType.FacilityContact
        })
      }
    },
    dropOccurred(){
      this.dropCount++;
    }
  },
})



// WEBPACK FOOTER //
// ./src/components/communications/Communications.ts